/**
 * 361 Sleep — Section 5
 * Line-by-line reveal for «لمن صُمم هذا القناع؟»:
 * the rail draws down while each cream dot and text line lands in sequence.
 */
(function () {
  'use strict';

  var BOOTED = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenGsap(fn) {
    if (window.gsap && window.ScrollTrigger) {
      fn(window.gsap, window.ScrollTrigger);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.gsap && window.ScrollTrigger) {
        clearInterval(timer);
        fn(window.gsap, window.ScrollTrigger);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initSection(section, gsap) {
    var card = section.querySelector('[data-audience-card]');
    var title = section.querySelector('[data-audience-title]');
    var list = section.querySelector('[data-audience-list]');
    var rail = section.querySelector('[data-audience-rail]');
    var items = section.querySelectorAll('[data-audience-item]');
    var dots = section.querySelectorAll('[data-audience-dot]');
    var texts = section.querySelectorAll('.audience361__item-text');
    if (!card || !items.length) return;

    if (section._audienceListCtx) {
      section._audienceListCtx.revert();
      section._audienceListCtx = null;
    }

    var ctx = gsap.context(function () {
      var mm = gsap.matchMedia();

      mm.add('(prefers-reduced-motion: reduce)', function () {
        gsap.set([title, rail, dots, texts].filter(Boolean), { clearProps: 'all' });
        if (rail) gsap.set(rail, { scaleY: 1 });
        if (dots.length) gsap.set(dots, { scale: 1, opacity: 1 });
        if (texts.length) gsap.set(texts, { opacity: 1, x: 0 });
      });

      mm.add('(prefers-reduced-motion: no-preference)', function () {
        var count = items.length;
        var step = 0.16;
        var railDur = Math.max(0.9, count * step + 0.15);

        gsap.set(rail, { scaleY: 0, transformOrigin: 'top center' });
        gsap.set(dots, { scale: 0, opacity: 0, transformOrigin: 'center center' });
        /* Slide in from the right (RTL start) toward the dots */
        gsap.set(texts, { opacity: 0, x: 18 });
        if (title) gsap.set(title, { opacity: 0, y: 18 });

        var tl = gsap.timeline({
          defaults: { ease: 'power2.out' },
          scrollTrigger: {
            trigger: card,
            start: 'top 78%',
            toggleActions: 'play none none none'
          }
        });

        if (title) {
          tl.to(title, { opacity: 1, y: 0, duration: 0.65 }, 0);
        }

        /* Rail draws while the lines land — synced to the stagger length */
        if (rail) {
          tl.to(
            rail,
            {
              scaleY: 1,
              duration: railDur,
              ease: 'power1.inOut'
            },
            0.18
          );
        }

        if (dots.length) {
          tl.to(
            dots,
            {
              scale: 1,
              opacity: 1,
              duration: 0.42,
              ease: 'back.out(2.1)',
              stagger: step
            },
            0.28
          );
        }

        if (texts.length) {
          tl.to(
            texts,
            {
              opacity: 1,
              x: 0,
              duration: 0.55,
              ease: 'power3.out',
              stagger: step
            },
            0.34
          );
        }
      });
    }, section);

    section._audienceListCtx = ctx;
  }

  function boot() {
    whenGsap(function (gsap, ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      document.querySelectorAll('[data-audience361]').forEach(function (section) {
        initSection(section, gsap);
      });

      if (!BOOTED) {
        BOOTED = true;
        window.addEventListener(
          'load',
          function () {
            ScrollTrigger.refresh();
          },
          { once: true }
        );
      }
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    if (!root.querySelector('[data-audience361]') && !(root.matches && root.matches('[data-audience361]'))) {
      return;
    }
    boot();
  });
})();
